import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import {
  doc,
  getDoc,
  getDocs,
  updateDoc,
  setDoc,
  collection,
} from "firebase/firestore";
import Loader from "../components/Loader";
import DataTable from "react-data-table-component";
import "react-tabs/style/react-tabs.css"; // Import react-tabs styles
import "./Dashboard.css"; // Custom styles
import { openDB } from "idb";
import { db } from "../firebase"; // Import your Firebase config
import axios from "axios";

ReactModal.setAppElement("#root"); // Important for accessibility

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const readData = async () => {
      if (!data) return;

      const filterData = data.filter(value =>
        value?.survey_id?.toString().toLowerCase().includes(searchText.toLowerCase())
      );

      setFilteredData(filterData);
    };

    readData();
  }, [searchText, data]);


    useEffect(() => {
    const readData = async () => {
      const querySnapshot = await getDocs(collection(db, "cint"));
      const documentsArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const parsedArray = documentsArray.map((item) => JSON.parse(item?.data));
      const singleArray = parsedArray.flat();
      const finalArray = singleArray?.filter((row) => row?.is_live === true);
      setData(finalArray);
    };
    readData();
  }, []);

  const openDatabase = async () => {
    const dbName = "arrayStorageDB";
    const storeName = "arrayStore";

    const db = await openDB(dbName, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: "id" });
        }
      },
    });
    return db;
  };

  const fetchWebhooks = async () => {
    try {
      const response = await axios.get("/api/webhook");
      const mergedArray = response.data.reduce((accumulator, currentArray) => {
        return accumulator.concat(currentArray);
      }, []);

      const result = updateArrayWithConditions(data, mergedArray);
      const uniqueArray = Object.values(
        result.reduce((acc, obj) => {
          acc[obj.survey_id] = obj;
          return acc;
        }, {})
      );

      const storeName = "arrayStore";
      const db = await openDatabase();
      const tx = db.transaction(storeName, "readwrite");
      const store = tx.objectStore(storeName);

      const entry = { id: "myArray", data: JSON.stringify(uniqueArray) };
      await store.put(entry);
      await tx.done;
    } catch (error) {
      console.error("Error fetching webhooks:", error);
    }
  };

  useEffect(() => {
    const handleReload = async () => {
      const isReloaded = sessionStorage.getItem("isPageReloaded");

      if (isReloaded) {
        const storeName = "arrayStore";
        const database = await openDatabase();
        const tx = database.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);

        const entry = await store.get("myArray");
        await tx.done;

        if (entry) {
          let data = JSON.parse(entry.data);
          let finaldata = data?.filter(
            (row) => row?.message_reason !== "deactivated"
          );
          console.log("finaldata => " + finaldata.length);
          const distinctData = [
            ...new Map(
              finaldata.map((item) => [item.survey_id, item])
            ).values(),
          ];
          let ary = chunkArray(distinctData, 50);
          try {
            ary?.map(async (item, index) => {
              const cintRef = doc(db, "cint", `batch_${index}`);
              const docSnap = await getDoc(cintRef);
              await delay(1050);
              if (docSnap.exists()) {
                await updateDoc(cintRef, {
                  data: JSON.stringify(item),
                });
              } else {
                await setDoc(cintRef, {
                  data: JSON.stringify(item),
                });
              }
            });
          } catch (error) {
            console.log(`There was an error in adding book: ${error}`);
          }
          deleteArrayFromIDB();
        } else {
          console.log("No array found in IndexedDB.");
        }
      } else {
        console.log("Page loaded for the first time!");
        sessionStorage.setItem("isPageReloaded", "true");
      }
    };

    handleReload();

    return () => {
      sessionStorage.removeItem("isPageReloaded");
    };
  }, []);

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function chunkArray(array, chunkSize) {
    return Array.from(
      { length: Math.ceil(array.length / chunkSize) },
      (_, index) => {
        return array.slice(index * chunkSize, (index + 1) * chunkSize);
      }
    );
  }

  const deleteArrayFromIDB = async () => {
    try {
      const storeName = "arrayStore";
      const db = await openDatabase();
      const tx = db.transaction(storeName, "readwrite");
      const store = tx.objectStore(storeName);

      await store.delete("myArray");
      await tx.done;
      console.log("Array deleted from IndexedDB.");
    } catch (error) {
      console.error("Error deleting array from IndexedDB:", error);
    }
  };

  function updateArrayWithConditions(x, y) {
    if (x.length === 0) {
      return y;
    }
    y.forEach((yItem) => {
      const index = x.findIndex((xItem) => xItem.survey_id === yItem.survey_id);

      switch (yItem.message_reason) {
        case "updated":
          if (index !== -1) {
            x[index] = yItem;
          }
          break;
        case "new":
          if (index === -1) {
            x.push(yItem);
          }
          break;
        case "deactivated":
          if (index !== -1) {
            x.splice(index, 1);
          }
          break;
        default:
          console.log(`Unhandled message_reason: ${yItem.message_reason}`);
      }
    });

    return x;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      fetchWebhooks();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const formatLOI = (loi) => `${loi} Min`;
  const formatDecimal = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return 0; // fallback if value is invalid
    return parseFloat(num.toFixed(2));
  };

  // const handleRowClick = async (row) => {
  //   console.log("Row clicked:", row);
  //   await storeData("details", row);
  //   window.open(
  //     `https://webhook-cint.vercel.app/details/${row.survey_id}`,
  //     "_blank"
  //   );
  // };

  const getRate = (rate) => {
    const inputValue = formatDecimal(rate);

    if (inputValue < 0) return 0; // prevent negative errors

    if (inputValue < 1) return 20;
    else if (inputValue < 2) return 35;
    else if (inputValue < 5) return 60;
    else if (inputValue < 7) return 70;
    else if (inputValue < 9) return 80;
    else if (inputValue < 11) return 90;
    else if (inputValue < 16) return 100;
    else if (inputValue < 19) return 110;
    else if (inputValue < 25) return 120;
    else return 140;
  };

  const storeData = async (key, value) => {
    const jsonValue = JSON.stringify(value);
    await sessionStorage.setItem(key, jsonValue);
  };

  const handleRedirect = (row) => {
    let finalRow = JSON.parse(JSON.stringify(row));
    finalRow.country = parseLocale(row?.country_language)?.country;
    finalRow.language = parseLocale(row?.country_language)?.language;
    localStorage.setItem("userData", JSON.stringify(row));
    window.open("/details", "_blank", "noopener,noreferrer");
  };
  const parseLocale = (locale) => {
    if (!locale || typeof locale !== "string") {
      return { language: null, country: null };
    }

    // normalize input (lowercase language, uppercase country)
    const parts = locale.split(/[_-]/); // handles "en_us", "en-US"
    if (parts.length !== 2) {
      return { language: null, country: null };
    }

    const language = parts[0].toUpperCase();
    const country = parts[1].toUpperCase();

    return { language, country };
  };
  const columns = [
    { name: "Survey ID", selector: (row) => row?.survey_id },
    { name: "Name", selector: (row) => row?.survey_name },
    {
      name: "Country",
      selector: (row) =>
        parseLocale(row?.country_language)?.country +
        " - " +
        parseLocale(row?.country_language)?.language,
      sortable: true,
    },
    { name: "IR", selector: (row) => row?.bid_incidence + "%", sortable: true },
    {
      name: "LOI",
      selector: (row) => parseInt(row?.bid_length_of_interview) + " Min",
      sortable: true,
      sortFunction: (rowA, rowB) =>
        parseInt(rowA.bid_length_of_interview) -
        parseInt(rowB.bid_length_of_interview),
    },
    {
      name: "Remaining",
      selector: (row) => row?.total_remaining,
      sortable: true,
    },
    {
      name: "Overall Completes",
      selector: (row) => row?.overall_completes,
      sortable: true,
    },
    { name: "Priority", selector: (row) => row?.cpi + "%", sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <span
          onClick={() => handleRedirect(row)}
          style={{ cursor: "pointer", color: "#007bff" }}
          title="Open in Modal"
        >
          🔗
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    // { name: "Rate", selector: (row) => "₹" + getRate(row.CPI), sortable: true },
  ];

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by Survey ID"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="search-input"
        />
      </div>

      <DataTable
        columns={columns}
        data={searchText.length ? filteredData : data}
        paginationPerPage={25}
        pagination
        highlightOnHover
        striped
        responsive
        pointerOnHover
      />
    </div>
  );
};

export default Dashboard;
